(function ($) {
    $('.quote-modal .close-quote-modal').on('click', function() {
        $('.quote-modal').removeClass('active');
    })
})(jQuery);